import type { IModule } from "angular";
import { module } from "angular";
import "angular-agility/dist/angular-agility";
import "angular-ui-bootstrap";
import "ng-idle";
import AuthConfig from "./AuthConfig";

import "./Auth.scss";

export const app: IModule = module("mmAuth", [
    "ui.bootstrap",
    "aa.formExtensions",
    "aa.notify",
    "pascalprecht.translate",
    "ngIdle",
    "irUtils",
    "mmModels",
    "mmHttpAuthInterceptor",
    "LocalStorageModule",
]).config(AuthConfig);
